import React from 'react';
import { Modal, Button } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import '../css/style.less';
import FomeList from './components/FomeList';

class TreatGroupArr extends React.Component { 

    handleDomRender = () => {
        const Config = [
            {
                label: '治疗组别',
                name: 'treatGroupList',
                type: 'Table',
                typeProperty: {
                    columns: [{
                        title: '组别',
                        tebleItemKey: 'groupName',
                        type: 'text',
                        shouldRowSpan: true,
                        width: 80,
                    }, {
                        title: '访视方案名称',
                        tebleItemKey: 'visitGroupingName',
                        type: 'Input',
                        shouldRowSpan: true,
                        width: 120,
                    }, {
                        title: '随机病例数',
                        tebleItemKey: 'randomCaseNum',
                        type: 'InputNumber',
                        shouldRowSpan: true,
                        width: 100,
                    }, {
                        title: '药物数量',
                        tebleItemKey: 'medicationNumberId',
                        showName: 'medicationNumberName',
                        type: 'Select',
                        shouldRowSpan: true,
                        width: 100,
                        typeProperty: {
                            style: { width: '100%' },
                        }
                    }, {
                        title: '给药途径',
                        tebleItemKey: 'routeName',
                        type: 'text',
                        width: 80,
                    }, {
                        title: '给药类别',
                        tebleItemKey: 'routeType',
                        type: 'text',
                        width: 80,
                    }, {
                        title: '药物名称',
                        tebleItemKey: 'drugName',
                        type: 'text',
                        width: 80,
                    }, {
                        title: '来院访视周期',
                        tebleItemKey: 'visitCycleShow',
                        type: 'text',
                        width: 80,
                        className: 'header-blue',
                    }, {
                        title: '来院用药频率(指的是患者来院访视用药)',
                        tebleItemKey: 'medicationCycleShow',
                        type: 'text',
                        width: 120,
                        className: 'header-orange',
                    }, {
                        title: '治疗期来院用药次数',
                        tebleItemKey: 'medicationShow',
                        type: 'text',
                        width: 120,
                    }, {
                        title: '静脉数',
                        tebleItemKey: 'veinNum',
                        type: 'text',
                        shouldRowSpan: true,
                        width: 80,
                    }],
                },
            }];
        return Config
    }

    render(){
        const { customerParams } = this.props;
        return (
            <div>
                <FomeList
                    params={customerParams}
                    DomConfig={this.handleDomRender()}
                />
            </div>
        )
    }
}

class SchemeInfor extends React.Component {

    state = {
        visible: false,
        params: {},
        record: {},
        KeyAnalysisData: {},
        customerParams: {},
        evaluateVisitFeeData: {},
    };

    loadData = (evaluateRecordId) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateRecordView,//项目基本信息
                        evaluateRecordCustomer,//客户项目参数
                        evaluateServeConfigList, //项目服务内容
                        evaluateRecordServeList,//项目服务内容-选中的值
                    }
                } = res;
                const evaluateRecordServeIds = (evaluateRecordServeList || []).map(el => el.evaluateServeId).join(',');
                this.setState(
                    {
                        params: {
                            evaluateRecordId,
                            ...evaluateRecordView,
                            ...evaluateRecordCustomer,
                            evaluateRecordServeIds,
                        },
                        evaluateServeConfigList,
                    }
                );
            },
        }
        $.sendRequest(options);
    }

    loadKeyAnalysisData = (evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.viewEvaluateRecordDifficulty,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    KeyAnalysisData: (res.data || {}),
                });
                
            }
        };
        $.sendRequest(options);
    };

    isWorthObj = (obj) => {
        // 先验证输入是否为对象（排除null/数组等）
        if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
            return false;
        }
        return Object.keys(obj).length !== 0;
    }

    loadCustomerParams = (evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.viewEvaluateRecordCalculate,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { evaluateRecordCalculate = {}, evaluateRecordCalculateExternal } = res
                const { treatGroupList = [] } = evaluateRecordCalculate;
                const newTreatGroupList = [];
                treatGroupList.map((el, index) => {
                    const { cycleShow, hospitalMedicationFrequencyShow, routeList, customFrequency, treatmentPeriodFrequencyShow } = el;
                    el.groupName = `治疗组别${index + 1}`
                    el.groupIndex = index;
                    el.cycleRangeShow = customFrequency ? customFrequency : ((cycleShow && hospitalMedicationFrequencyShow) ? `${cycleShow}(${hospitalMedicationFrequencyShow})` : '');
                    const len = (routeList || []).length;
                    if (len) {
                        routeList.forEach((route, routeIndex) => {
                            const { 
                                evaluateHospitalMedicationFrequencyOptimize = {},
                            } = route;
                            if (this.isWorthObj(evaluateHospitalMedicationFrequencyOptimize)) {
                                newTreatGroupList.push({
                                    ...el,
                                    ...route,
                                    ...evaluateHospitalMedicationFrequencyOptimize,
                                    rowSpan: routeIndex === 0 ? len : 0,
                                    rowId: `${el.evaluateRecordCalculateTreatGroupId}-${route.routeId}`
                                })
                            } else {
                                newTreatGroupList.push({
                                    ...el,
                                    ...route,
                                    visitCycleShow: cycleShow,
                                    medicationCycleShow: hospitalMedicationFrequencyShow,
                                    medicationShow: treatmentPeriodFrequencyShow,
                                    rowSpan: routeIndex === 0 ? len : 0,
                                    rowId: `${el.evaluateRecordCalculateTreatGroupId}-${route.routeId}`
                                })
                            }
                        });
                    } else {
                        newTreatGroupList.push({
                            ...el,
                            rowSpan: 1,
                            rowId: el.evaluateRecordCalculateTreatGroupId
                        });
                    }

                })
                this.setState({
                    customerParams: {
                        evaluateRecordId,
                        ...evaluateRecordCalculate,
                        treatGroupList: newTreatGroupList,
                        ...evaluateRecordCalculateExternal,
                    }
                })
            }
        };
        $.sendRequest(options);
    }

    loadEvaluateVisitFeeData = (evaluateRecordId) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateVisitFeeData,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { evaluateVisitQuotation } = res;
                this.setState({
                    evaluateVisitFeeData: evaluateVisitQuotation ? { ...evaluateVisitQuotation } : {},
                })
            },
        };
        $.sendRequest(options);
    };

    show = record => {
        const { evaluateRecordId } = record;
        this.setState({
            visible: true,
            record,
        }, () => {
            this.loadData(evaluateRecordId);
            this.loadKeyAnalysisData(evaluateRecordId);
            this.loadCustomerParams(evaluateRecordId);
            this.loadEvaluateVisitFeeData(evaluateRecordId);
        });
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible, params, KeyAnalysisData, customerParams, evaluateVisitFeeData } = this.state;
        const {
            evaluateSerialNumber,
            diseaseName,
            investigationAreaName,
            randomCaseNum,
            treatmentPeriod,
            researchCycle,
            treatGroupCount,
            startSiteNum,
        } = params;
        const { 
            productQualityState,
            programmeQualityState,
            programmeInRowState,
            researchProcessCorrelation,
            contendProductExperimentState,
        }= KeyAnalysisData;
        const {
            customerPredictedAverageInGroupRate,
            smoPredicatedAverageInGroupRate,
            planStandardVisitAmount,
        } = customerParams;
        const {
            fteAmount,
        } = evaluateVisitFeeData;
        return (
            <Modal
                title="方案基本信息"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="1050px"
                bodyStyle={{
                    minHeight: 700
                }}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont">
                    <ul className="preview-list">
                        <li className="title"><h4>1.方案基本信息</h4></li>
                        <li>
                            <div className="item">
                                <label className="ui-label">方案编号</label>
                                <span className="ui-text">{evaluateSerialNumber}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">适应症</label>
                                <span className="ui-text">{diseaseName}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">治疗领域</label>
                                <span className="ui-text">{investigationAreaName}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">随机病例数</label>
                                <span className="ui-text">{randomCaseNum}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">治疗期（月）</label>
                                <span className="ui-text">{treatmentPeriod}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">研究周期（月）</label>
                                <span className="ui-text">{researchCycle}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">合同FTE数</label>
                                <span className="ui-text">{fteAmount}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">标准访视数</label>
                                <span className="ui-text">{planStandardVisitAmount}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label" style={{width: 201}}>客户参数预测平均入组速率预测</label>
                                <span className="ui-text">{customerPredictedAverageInGroupRate}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">此项目入组速率预估</label>
                                <span className="ui-text">{smoPredicatedAverageInGroupRate}（pts/site/m）</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">治疗组别数</label>
                                <span className="ui-text">{treatGroupCount}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">启动中心数</label>
                                <span className="ui-text">{startSiteNum}</span>
                            </div>
                        </li>

                        <li className="title"><h4>2.治疗组别信息</h4></li>
                        <li>
                            <TreatGroupArr customerParams={customerParams}/>
                        </li>

                        <li className="title"><h4>3.重点难点分析</h4></li>
                        <li>
                            <div className="item">
                                <label className="ui-label">研发产品优劣情况</label>
                                <span className="ui-text" style={{'white-space': 'normal', width: '700px'}}>{productQualityState}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">治疗方案优劣情况</label>
                                <span className="ui-text" style={{'white-space': 'normal', width: '700px'}}>{programmeQualityState}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">项目方案入排相关</label>
                                <span className="ui-text" style={{'white-space': 'normal', width: '700px'}}>{programmeInRowState}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">研究流程相关</label>
                                <span className="ui-text" style={{'white-space': 'normal', width: '700px'}}>{researchProcessCorrelation}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">竞争产品或竞争实验情况</label>
                                <span className="ui-text" style={{'white-space': 'normal', width: '700px'}}>{contendProductExperimentState}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default SchemeInfor;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/SchemeInfor.js